import './Description.css'
import link_to from '../photos/open-new-page-icon.png'
import download from '../photos/file-download-icon.png'
import { useEffect } from "react";

const WebinarDescription = (props) => {
    //Set the height of description to be fixed at 300px at the initial load for better view
    useEffect(() => {
        const web_desc_div = document.querySelectorAll("div.webinar-desc")
        web_desc_div.forEach(div => {
            if (div.clientHeight >= 300) {
                div.style.height = '300px';
            } else {
                div.nextSibling.style.display = 'none'
            }
        })
    }, [])

    return (
        <div className='webinar-desc'>
            <h3> {props.title} </h3>
            <div className='recording-div'>
                <h4> Recording </h4>
                <div>
                    <img alt='link' src={link_to} onClick={() => window.open(props.recording_link)} />
                </div>
            </div>
            {props.survey_link &&
                <div className='post-survey-div'>
                    <h4> Post-webinar Survey </h4>
                    <div>
                        <img alt='link' src={link_to} onClick={() => window.open(props.survey_link)} />
                    </div>
                </div>
            }
            {props.presentation_slides &&
                <div className='presentation-slide-div'>
                    <h4> Presentation Slides </h4>
                    <div>
                        <img alt='link' src={download} onClick={() => window.open(props.presentation_slides)} />
                    </div>
                </div>
            }
            {/*additional resources for each seminar*/}
            {props.resources}
        </div>
    )
}


export default WebinarDescription;